import { render, staticRenderFns } from "./SupportScreen.vue?vue&type=template&id=4a97c980"
import script from "./SupportScreen.vue?vue&type=script&lang=js"
export * from "./SupportScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports